function formatearFechaCorta(fecha) {
    const date = new Date(fecha);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    return `${dd}/${mm}/${yyyy} ${hh}:${min}:${ss}`;
}

function formatearHoraCorta(ts) {
    if (!ts) return '—';
    const date = new Date(ts);
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${hh}:${min}`;
}

/**
 * ExitTicketThermal
 *
 * Consume directamente el body de POST /api/salidas/crear:
 *   { salida: {...}, tickets: [...] }
 */
const ExitTicketThermal = ({ data }) => {
    const { salida, tickets = [] } = data;

    return (
        <html>
            <head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <title>Ticket de Salida #{salida?.id}</title>
                <style>{`
                    * { box-sizing: border-box; margin: 0; padding: 0; }

                    body {
                        font-family: 'Courier New', Courier, monospace;
                        font-size: 11px;
                        color: #000;
                        background: #fff;
                        width: 72mm;
                        margin: 0 auto;
                        padding: 4px 4px 16px 4px;
                    }

                    .doc-header {
                        text-align: center;
                        font-size: 13px;
                        font-weight: bold;
                        border-bottom: 1px dashed #000;
                        padding-bottom: 4px;
                        margin-bottom: 6px;
                        text-transform: uppercase;
                    }

                    .doc-meta {
                        font-size: 10px;
                        margin-bottom: 8px;
                        text-align: center;
                    }

                    .doc-meta .unit {
                        font-size: 12px;
                        font-weight: bold;
                        text-transform: uppercase;
                        margin-bottom: 2px;
                    }

                    .badge {
                        display: inline-block;
                        border: 1px solid #000;
                        padding: 1px 6px;
                        border-radius: 3px;
                        font-size: 9px;
                        font-weight: bold;
                        text-transform: uppercase;
                        margin-top: 2px;
                    }

                    table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-top: 4px;
                    }

                    th {
                        font-size: 9px;
                        font-weight: bold;
                        text-transform: uppercase;
                        border-bottom: 1px solid #000;
                        padding: 1px 2px;
                        text-align: left;
                    }

                    td {
                        font-size: 10px;
                        padding: 2px 2px;
                        vertical-align: top;
                        border-bottom: 1px dotted #ccc;
                    }

                    tr:last-child td { border-bottom: none; }

                    .col-num  { width: 8%;  color: #888; }
                    .col-geo  { width: 60%; }
                    .col-prog { width: 32%; }

                    .footer {
                        border-top: 1px dashed #000;
                        margin-top: 8px;
                        padding-top: 6px;
                        font-size: 10px;
                        text-align: center;
                    }

                    @media print {
                        @page {
                            margin: 6mm;
                        }
                        body {
                            font-size: 14px; /* mucho más grande de lo que parece necesario */
                            width: 100%;
                        }
                        .doc-header { font-size: 16px; }
                        .doc-meta { font-size: 12px; }
                        .doc-meta .unit { font-size: 15px; }
                        th { font-size: 12px; }
                        td { font-size: 14px; }
                        .footer { font-size: 12px; }
                    }
                `}</style>
            </head>
            <body>
                <div className="doc-header">Ticket de Salida</div>

                <div className="doc-meta">
                    <div className="unit">{salida?.deviceName}</div>
                    <div>Salida: {formatearFechaCorta(salida?.date)}</div>
                    <div>Ruta: {salida?.subrouteName}</div>
                    <div>Grupo: {salida?.groupName}</div>
                    {salida?.manual && <span className="badge">Manual</span>}
                </div>

                <table>
                    <thead>
                        <tr>
                            <th className="col-num">#</th>
                            <th className="col-geo">GEO</th>
                            <th className="col-prog">PROG</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tickets.map((t, idx) => (
                            <tr key={t.id}>
                                <td className="col-num">{idx + 1}</td>
                                <td className="col-geo">{t.geofenceName}</td>
                                <td className="col-prog">{formatearHoraCorta(t.expectedTime)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className="footer">
                    Fin esperado: {formatearHoraCorta(salida?.endingDate)}
                </div>
            </body>
        </html>
    );
};

export default ExitTicketThermal;